<template>
  <Select
    :model-value="language.language"
    :options="language.available"
    option-label="name"
    option-value="code"
    :aria-label="label"
    data-language-setting
    @update:model-value="language.choose"
  />
</template>

<script setup>
import Select from 'primevue/select';

import { useLanguageStore } from './languageStore.js';

// The Language setting: the languages the app is translated into, each shown
// in its own name. The same control on a phone and on a desktop. What choosing
// one does is the language store's.

defineProps({
    // The setting's name, as the Settings page shows it. It names the control
    // for a screen reader.
    label: { type: String, default: '' }
});

const language = useLanguageStore();
</script>
